import { render, staticRenderFns } from "./FundamentalFormApprovedCredit.vue?vue&type=template&id=95d0d26e&scoped=true&"
import script from "./FundamentalFormApprovedCredit.vue?vue&type=script&lang=js&"
export * from "./FundamentalFormApprovedCredit.vue?vue&type=script&lang=js&"
import style0 from "./FundamentalFormApprovedCredit.vue?vue&type=style&index=0&id=95d0d26e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d0d26e",
  null
  
)

export default component.exports